import { Component, OnInit } from '@angular/core';
import { UserImageModel } from '../../../api';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { RenterRegFormService } from '@accounts/operator/services/renter-reg-form.service';
import { FormGroup } from '@angular/forms';
import { RenterForm } from '@core/components/abstract/renter-form';

@Component({
  selector: 'renter-add-transport',
  templateUrl: './renter-add-transport.component.html',
  styleUrls: ['./renter-add-transport.component.scss']
})
export class RenterAddTransportComponent extends RenterForm implements OnInit {

  allowedPhotoTypes = [
    {
      type: UserImageModel.TypeEnum.TransportPassportFront,
      label: this.i18n('Фото оригинала свидетельства о госрегистрации ТС')
    }
  ];

  constructor(
    private renterRegFormService: RenterRegFormService,
    private i18n: I18n
  ) {
    super();
  }

  get form(): FormGroup {
    try {
      return this.renterRegFormService.transportForm;
    } catch (e) {
      throw new Error('Transport form was not built');
    }
  }

  get imagesForm(): FormGroup {
    try {
      return this.renterRegFormService.transportImagesForm;
    } catch (e) {
      throw new Error('Transport image form was not built');
    }
  }

  selectTransportFile({ image, type }) {
    this.renterRegFormService.transportImagesForm.get(type).setValue(image);
  }

  ngOnInit() {
  }

}
